import { Button } from "@progress/kendo-react-buttons";
import { TextBox, TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { useState } from "react";
import { protectedResources } from "../../authConfig";
import { useFetchWithMsal } from "../../hooks/useFetchWithMsal";
import { useNotificationAPI } from '../../components/NotificationProvider';

interface LabInvitesProps {
    labId?: number,
    facilityName: string,
    children?: React.ReactNode
}

const pageTitle = 'Lab Invite';

const LabInvite = (props: LabInvitesProps) => {
    const { isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });
    const { addNotification } = useNotificationAPI();

    const [userEmail, setUserEmail] = useState("");
    const [addedUserEmails, setAddedUserEmails] = useState([] as string[]);

    const userEmailChange = (event: TextBoxChangeEvent) => {
        setUserEmail(event.target.value + "");
    }

    const inviteUser = () => {
        var data = {
            LabId: props.labId,
            UserEmail: userEmail
        };

        execute("POST", protectedResources.apiLabInvite.endpoint + "CreateLabInvite/", data)
            .then(
                ((data: any) => {
                    if (data?.id > 0) {
                        addedUserEmails.push(userEmail);
                        setAddedUserEmails(addedUserEmails);
                        setUserEmail("");
                        addNotification('Invite sent', pageTitle, 'success');
                    } else if (data === undefined) {
                        addNotification('This user has already been invited', pageTitle, 'success');
                    }
                })
            );
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <div className="mb-3">
                        <label className="form-label">To add users to {props.facilityName}, enter their emails below</label><br></br>
                        <label className="form-label">Note: Invited users will have full access to the lab.</label><br></br>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Invite User Email:</label>
                        <TextBox value={userEmail} onChange={userEmailChange}></TextBox>
                    </div>
                    <Button disabled={isLoading} onClick={inviteUser}>Invite User</Button>

                    <div className="mb-3 mt-3">
                        <label className="form-label">Invited Users Emails:</label>
                        {addedUserEmails.map((_userEmail, index) => (
                            <div key={index}>&nbsp;&nbsp;{_userEmail}</div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LabInvite;